import * as T from './types';


export const compareNumbers = (a: number, b: number): number => a - b;

export const preparePublicationYearOptions = (year_count: T.StringToNumberObject, selectedPublicationYear: string): T.SelectorOption[] => {
  const publicationYearOptions: T.SelectorOption[] = [{
    name: `All Years (${year_count['total']})`,
    value: '0',
    count: year_count['total']
  }];
  const years: string[] = Object.keys(year_count).filter(year => year !== 'total');
  if (years.indexOf(selectedPublicationYear) === -1 && selectedPublicationYear !== '0') {
    years.push(selectedPublicationYear);
    year_count[selectedPublicationYear] = 0;
  }
  years.sort().reverse().forEach(year => {
    publicationYearOptions.push({
      name: `${year} (${year_count[year]})`,
      value: year,
      count: year_count[year]
    });
  });

  return publicationYearOptions;
};


const regex = /<\/?i>|<\/?b>|(&amp;|<\/?sup>|<\/?sub>|<\/?latex>)/;

export const toSafeInnerHTML = (inputString: string): string => {
  if (!inputString) {
    return '';
  }


  const returnString = inputString.split(regex).reduce((accumulator, currentValue, index) => {
    // Escape if pattern not found (even index), or don't (odd index)
    return accumulator + (index % 2 === 0 ? _customEscape(currentValue) : currentValue);
  }, '');

  return returnString;
};

// https://stackoverflow.com/questions/18749591/encode-html-entities-in-javascript
const _customEscape = (inputString: string): string => {
  return inputString.replace(/[\u00A0-\u9999<>&]/g, function (i) {
    return '&#' + i.charCodeAt(0) + ';';
  });
};

// const range = (start:number, stop:number, step:number) => Array.from({ length: (stop - start) / step + 1}, (_, i) => start + (i * step));

export const isNull = (v: any): boolean => {
  return !v && typeof(v)!=="undefined" && v!==0;
}